import { useMemo } from 'react';
import QRCode from 'qrcode';

/**
 * QR code d'ajout d'un compte dans une application d'authentification.
 *
 * ── Dessiné ICI, jamais demandé à un service tiers ──────────────────────────
 * Le texte encodé contient le secret de la double authentification : l'envoyer
 * à un générateur en ligne, c'est le confier à quelqu'un d'autre. La matrice
 * est calculée dans le navigateur et tracée en SVG par React — sans
 * `innerHTML`.
 *
 * ── Noir sur blanc, quel que soit le thème ──────────────────────────────────
 * Un QR code inversé en mode sombre n'est pas lu par toutes les applications :
 * le fond reste blanc, avec sa marge de silence.
 */
export function QrCode({ texte, taille = 192, libelle }: {
  texte: string;
  taille?: number;
  libelle: string;
}) {
  const { chemin, cote } = useMemo(() => {
    const { modules } = QRCode.create(texte, { errorCorrectionLevel: 'M' });
    const n = modules.size;
    let d = '';
    for (let y = 0; y < n; y++) {
      for (let x = 0; x < n; x++) {
        if (modules.get(y, x)) d += `M${x} ${y}h1v1h-1z`;
      }
    }
    return { chemin: d, cote: n };
  }, [texte]);

  const marge = 4;
  return (
    <svg
      role="img"
      aria-label={libelle}
      width={taille}
      height={taille}
      viewBox={`${-marge} ${-marge} ${cote + 2 * marge} ${cote + 2 * marge}`}
      shapeRendering="crispEdges"
      className="rounded-lg"
    >
      <rect x={-marge} y={-marge} width={cote + 2 * marge} height={cote + 2 * marge} fill="#fff" />
      <path d={chemin} fill="#000" />
    </svg>
  );
}
